import styled from "@emotion/styled";
import { Chip, Tooltip, useTheme } from "@mui/material";
import { omit, omitBy } from "lodash";
import { useArbitrageFilters } from "src/Modules/Arbitrage/context";
import CloseIcon from "@mui/icons-material/Close";
import CloudQueueIcon from "@mui/icons-material/CloudQueue";

export const ActiveFilterList = () => {
  const theme = useTheme();

  const {
    setActiveFiltersByName,
    activeFiltersByName,
    filterCatalogByName,
    currentScope,
  } = useArbitrageFilters();

  return (
    <Container>
      <ActiveFiltersArea>
        {Boolean(Object.keys(activeFiltersByName).length) && (
          <ClearBtn
            onClick={
              () =>
                setActiveFiltersByName((prev: any) =>
                  omitBy(prev, (_, k) => !filterCatalogByName[k]?.mandatory)
                ) //TODO: this not work remotely
            }
          >
            Clear filters
          </ClearBtn>
        )}
        {Object.entries(activeFiltersByName).map(([filterName, value]) => {
          const isMandatory = !!filterCatalogByName[filterName]?.mandatory;
          const Icon = filterCatalogByName[filterName].icon;
          const isRemoteFilter =
            !!filterCatalogByName[filterName].remoteSyncScopes?.includes(
              currentScope
            );

          return (
            <Chip
              key={filterName}
              icon={
                <>
                  <Icon
                    style={{
                      width: ".9rem",
                      color: theme.palette.primary.main,
                    }}
                  />
                  {isRemoteFilter && (
                    <CloudQueueIcon
                      style={{
                        width: ".7rem",
                        marginLeft: "0.4rem",
                      }}
                    />
                  )}
                </>
              }
              variant="outlined"
              label={`${filterName}: ${
                Array.isArray(value)
                  ? value.length > 3
                    ? value.slice(0, 3).join(", ") + ` ( +${value.length - 3} )`
                    : value
                  : value
              }`}
              size="small"
              deleteIcon={
                isMandatory ? (
                  <Tooltip title={`${filterName} is mandatory`}>
                    <CloseIcon />
                  </Tooltip>
                ) : (
                  <CloseIcon />
                )
              }
              onDelete={() =>
                !isMandatory &&
                setActiveFiltersByName(
                  omit(activeFiltersByName, filterName),
                  filterName,
                  null
                )
              }
            />
          );
        })}
      </ActiveFiltersArea>
    </Container>
  );
};

const Container = styled.div({
  display: "flex",
});

const ActiveFiltersArea = styled.div({
  display: "flex",
  flexFlow: "wrap",
  alignItems: "center",
  "& > *": {
    marginRight: ".5rem",
  },
});

const ClearBtn = styled.span({
  borderRadius: 5,
  border: "0.5px solid #3f51b5",
  padding: "0.5rem 0.5rem",
  color: "#7B8ADE",
  cursor: "pointer",
  userSelect: "none",
});
